import { ProcurementItem } from 'helpers/fakeData';

export enum BlockType {
  Commodity = 'commodity',
}
interface BaseBlock {
  id: string;
  type: BlockType;
}

export interface CommodityBlock extends BaseBlock {
  type: BlockType.Commodity;
  commodity?: ProcurementItem;
}

export type Block = BaseBlock | CommodityBlock;

export function isCommodityBlock(block: Block): block is CommodityBlock {
  return block.type === BlockType.Commodity;
}

export type UpdateBlock = {
  commodity?: ProcurementItem;
};
